<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('health_information').toUpper() }}</h5>
        <div class="border rounded p-4 mb-4 bg-white shadow-sm">
            <b-row>
                <b-col cols="12" md="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('disability_type') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'type_of_disability_name') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('disability_rate') }}</label>
                        <div>
                            {{ studentProgram.disability_rate ? '%' + Math.floor(studentProgram.disability_rate) : '-' }}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('surgery_or_discomfort') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'surgery_illness_history') }}
                        </div>
                    </div>
                    <div class="label-as-input-div">
                        <label>{{ $t('used_drugs') }}</label>
                        <div>
                            {{ getObjectValue(studentProgram, 'medicines') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_updatehealth') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal"
                     size="xl"
                     @bHideModalHeaderClose="clearFormData()"
                     :onHideOnlyX="true"
                     v-if="checkPermission('studentprogram_updatehealth') && editMode">
            >
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            }
        }
    }
</script>

